/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'input-true': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M442.88 1010.176C294.912 826.88 120.832 688.128 0 644.608l286.72-172.032 138.24 268.8s225.28-545.792 581.12-727.552c-7.68 130.048-43.008 242.688 17.92 381.44-156.16 35.328-476.672 424.96-581.12 614.912z"/>'
  }
})
